import type { ReactNode } from "react";
import styles from "./TimerDurationButton.module.css";

type TimerDurationButtonProps = {
  onClick: VoidFunction;
  children: ReactNode;
  /**
   * Optional accessible label. Required when the button's children are
   * icon-only (e.g. the custom-add affordance); duration tiles like "1:00"
   * already have textual children and can omit it.
   */
  "aria-label"?: string;
};

export default function TimerDurationButton({ onClick, children, "aria-label": ariaLabel }: TimerDurationButtonProps) {
  return (
    <button type="button" onClick={onClick} aria-label={ariaLabel} className={styles.button}>
      {children}
    </button>
  );
}
